import React from 'react'
import type { MutationConfig } from '@ztechapps/common.utils'
import { useConfirmDialog, useError, useMutation } from '@ztechapps/common.hook'
import { BusyButton } from '@ztechapps/webui.button'

export const DeleteItemButton = ({
  itemId,
  invoiceId,
  name,
  disabled,
  deleteMutationConfig,
}: {
  itemId: string
  invoiceId: string
  name: string
  disabled: boolean
  deleteMutationConfig: MutationConfig
}) => {
  //queries.deleteInvoice_itemsConfig
  const [onDelete] = useMutation(deleteMutationConfig)
  const { onError } = useError()

  const { confirm } = useConfirmDialog({
    text: `Are you sure you remove '${name}'? This will remove the item from the invoice list. `,
    title: 'Remove invoice item?',
    buttons: { confirm: { text: 'Yes, remove it!' } },
  })

  const onDeleteItem = async () => {
    try {
      await confirm(() => onDelete({ filter: { 'items._id': itemId, _id: invoiceId } }))
    } catch (e) {
      onError(e)
    }
  }

  const title = disabled ? 'Only draft invoice can be deleted' : ''

  return <BusyButton icon={'trash'} bsStyle={'danger'} onClick={onDeleteItem} disabled={disabled} title={title} />
}
